<script setup lang="ts">
const emit = defineEmits(["close"]);
defineProps({
  headerText: {
    type: String,
    required: true,
  },
  bodyText: {
    type: String,
    required: true,
  },
  success: {
    type: Boolean,
    default: false,
  },
  isProcessing: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    required: false,
    default: null,
  },
});
const localePath = useLocalePath();
</script>
<template>
  <div>
    <div
      v-if="!isProcessing"
      class="flex flex-col items-center max-w-xs mx-auto mt-9 mb-6">
      <NuxtIcon
        :name="
          success ? 'mdi:check-circle-outline' : 'mdi:cancel-circle-outline'
        "
        class="w-20 h-20"
        :class="success ? 'text-success-300' : 'text-error-300'" />
      <p
        class="mt-4 text-neutral-200 font-bold text-xl text-center"
        data-test="wallet-created-successfully">
        {{ success ? headerText : $t("main.modalList.transactionFailed") }}
      </p>
      <p v-if="success" class="mt-1 text-neutral-300 text-center">
        {{ bodyText }}
      </p>
      <ModalOfferRichTextMessage
        v-else
        class="mt-1 text-neutral-300 text-center"
        :message="
          errorMessage
            ? $t(errorMessage)
            : $t('main.modalList.transactionFailedMessage')
        " />
    </div>
    <div v-else-if="isProcessing">
      <BaseIconPending class="mx-auto mt-6 mb-4 w-36" />
      <div class="mt-4 flex flex-col items-center gap-2">
        <p class="text-neutral-200 font-bold text-center">
          {{ $t("main.modalBuySuccess.inProgress") }}
        </p>
        <p class="text-neutral-300 text-center">
          {{ $t("main.modalBuySuccess.processing") }}
        </p>
      </div>
    </div>
    <div v-else class="flex flex-col items-center">
      <NuxtIcon
        name="mdi:cancel-circle-outline"
        :alt="$t('main.imageAltTexts.failure')"
        class="mx-auto w-32 h-32 text-error-300" />
      <div class="mt-4 flex flex-col items-center gap-2">
        <p class="text-neutral-200 font-bold text-center">
          {{ $t("main.modalTransferSuccess.transferFailed") }}
        </p>
        <p class="text-neutral-300 text-center max-w-xs">
          {{ $t("main.modalTransferSuccess.transferIssue") }}
        </p>
      </div>
    </div>
    <div class="my-4 flex">
      <BaseButtonSubmit
        v-if="isProcessing"
        :text="$t('main.modalBuySuccess.goToActivity')"
        data-test="button-offer-pending"
        class="mx-auto"
        size="long"
        :contextual-styles="true"
        @click="navigateTo(localePath('/user-portal/activity'))" />
      <BaseButtonSubmit
        v-else
        :text="$t('main.modalOffer.close')"
        data-test="button-close-modal-offer-handle-success"
        size="long"
        class="mx-auto"
        :contextual-styles="true"
        @click="emit('close')" />
    </div>
  </div>
</template>
